// extracted by css-extract-rspack-plugin
export default {"video-player":"x1MpZc","videoPlayer":"x1MpZc"};